import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {NavLink, useLocation, useNavigate} from "react-router-dom";
import {googleLogout} from "@react-oauth/google";
import {FaAngleDown, FaAngleUp, FaBox, FaHeadset, FaHome, FaListAlt, FaSignOutAlt, FaPlus, FaStore} from "react-icons/fa";
import {postUserLogout} from "../../repository/Repo";
import {getAppToken} from "../../constants/GetAsyncStorageData";
import "../../assets/Css/Homedashboard.css";

const Sidebar = () => {
    const [loading, setLoading] = useState(false);
    const [productsOpen, setProductsOpen] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const refreshToken = useSelector((state) => state.refreshToken);

    const handleLogout = async () => {
        setLoading(true);
        try {
            const token = await getAppToken();
            if (!token) throw new Error("Your session has expired. Please sign in again.");
            const response = await postUserLogout("logout", {refresh_token: refreshToken});
            if (response?.status === false) throw new Error(response?.message || "Could not sign out.");
            googleLogout();
            localStorage.removeItem("usertoken");
            localStorage.removeItem("userdetails");
            dispatch({type: "SET_LOGGEDIN", payload: false});
            dispatch({type: "REMOVE_USER_DATA"});
            dispatch({type: "SET_TOKEN", payload: null});
            navigate("/login");
        } catch (error) {
            window.alert(error?.message || "Unable to sign out. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const productSectionActive = ["/productList", "/addProduct"].includes(location.pathname);
    const navClass = ({isActive}) => `sidebar-link${isActive ? " is-active" : ""}`;

    return (
        <aside className="sidebar-shell">
            <NavLink to="/home" className="sidebar-brand" aria-label="MotoSpar vendor home">
                <img src={require("../../assets/images/Logo.png")} alt="" />
                <span><strong>MotoSpar</strong><small>Vendor workspace</small></span>
            </NavLink>

            <div className="sidebar-section-label">WORKSPACE</div>
            <nav className="sidebar-nav" aria-label="Vendor navigation">
                <NavLink to="/home" className={navClass}>
                    <FaHome /><span>Overview</span>
                </NavLink>
                <button
                    type="button"
                    className={`sidebar-link sidebar-disclosure${productSectionActive ? " is-active" : ""}`}
                    onClick={() => setProductsOpen((open) => !open)}
                    aria-expanded={productsOpen || productSectionActive}
                >
                    <FaBox /><span>Products</span>{productsOpen || productSectionActive ? <FaAngleUp className="sidebar-caret" /> : <FaAngleDown className="sidebar-caret" />}
                </button>
                {(productsOpen || productSectionActive) && (
                    <div className="sidebar-subnav">
                        <NavLink to="/productList" className={navClass}><FaListAlt /><span>My products</span></NavLink>
                        <NavLink to="/addProduct" className={navClass}><FaPlus /><span>Add a product</span></NavLink>
                    </div>
                )}
                <NavLink to="/allOrders" className={navClass}>
                    <FaListAlt /><span>Orders</span>
                </NavLink>
                <NavLink to="/addProductRequest" className={navClass}>
                    <FaStore /><span>Product requests</span>
                </NavLink>
            </nav>

            <div className="sidebar-bottom">
                <div className="sidebar-section-label">ACCOUNT</div>
                <NavLink to="/support" className={navClass}><FaHeadset /><span>Help & support</span></NavLink>
                <button type="button" className="sidebar-link sidebar-logout" onClick={handleLogout} disabled={loading}>
                    <FaSignOutAlt /><span>{loading ? "Signing out…" : "Sign out"}</span>
                </button>
                <div className="sidebar-footer">MotoSpar · Vendor portal</div>
            </div>
        </aside>
    );
};

export default Sidebar;
